interface PaginationProps {
  page: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`h-9 w-9 cursor-pointer rounded-md text-sm font-medium transition-colors ${
            p === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        disabled={page >= total}
        onClick={() => onChange(page + 1)}
        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}